import type { TTypeIntention } from '../models/Intention.types'

export const getIntentionUserName = (intention: TTypeIntention | undefined, defaultUserName: string) =>
  intention?.user?.name || (intention && 'guestName' in intention && intention.guestName) || defaultUserName
